import React from 'react';
import { getErrorMessage } from '../utils/getErrorMessage';
import { Typography } from '@cube3/cubicle/src/core/atoms/Typography';

export const Errors = ({ errors, show = true }) => {
  return show && errors ? (
    <Typography color="critical" colorVariant="02" weight="body">
      {[]
        .concat(errors)
        .filter((e) => e !== null)
        .map((e) => (
          <div key={e}>{getErrorMessage(e) || e}</div>
        ))}
    </Typography>
  ) : null;
};
